module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Bold--24b1bb81f77894c7ccc2e4d4ff2101fb.24b1bb81f77894c7ccc2e4d4ff2101fb.woff";